import {TFunction} from "i18next";

/** Maps a raw chart or compare-row unit to its display phrase. An unrecognized
 *  unit passes through as is, so a caption never drops the unit silently.
 *  Shared by ChartBlock and CompareBlock so the mapping stays one rule. */
export const unitPhrase = (unit: string, t: TFunction): string => {
    switch (unit) {
        case "%":
            return t("chart.unit.percent");
        case "MNOK":
            return t("chart.unit.mnok");
        case "personer":
            return t("chart.unit.persons");
        default:
            return unit;
    }
};
